export const type = 'form.file';
